import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

// Figma sizes at 1920 (px)
const DROP = 64 // first vertical run below each card
const RADIUS = 20
const SPREAD = 17 // gap between neighbouring arrow tips
const GAP = 11 // arrow tip to logo circle
const ARROW = 6

// Mirrors the SCSS c() function: scales with the viewport, clamped 0.7–1.3
const px = value => value * gsap.utils.clamp(0.7, 1.3, window.innerWidth / 1920)

let mm

export const connectedCards = () => {

	if (mm) mm.revert()

	let sections = document.querySelectorAll('[data-animation="connected-cards"]')

	if (!sections.length) return

	mm = gsap.matchMedia()

	mm.add({
		isDesktop: '(min-width: 961px)',
		motion: '(prefers-reduced-motion: no-preference)',
	}, context => {

		let { isDesktop, motion } = context.conditions

		// The lines are hidden when the cards stack
		if (!isDesktop) return

		sections.forEach(section => {

			let svg = section.querySelector('.connectors'),
				cardList = section.querySelector('.cards'),
				cards = section.querySelectorAll('.card'),
				logo = section.querySelector('.logo'),
				lines = section.querySelectorAll('.connector-line'),
				arrows = section.querySelectorAll('.connector-arrow'),
				tl

			if (!svg || !logo || !cards.length) return

			// Each line runs from its card's bottom centre, down, across and into the top of the logo circle.
			// The viewBox matches the svg's pixel size so DrawSVG measures true lengths.
			let build = () => {

				let box = svg.getBoundingClientRect(),
					target = logo.getBoundingClientRect(),
					centre = target.left + target.width / 2 - box.left,
					y2 = target.top - box.top - px(GAP),
					r = px(RADIUS),
					a = px(ARROW)

				svg.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`)

				cards.forEach((card, i) => {

					let rect = card.getBoundingClientRect(),
						x1 = rect.left + rect.width / 2 - box.left,
						y1 = rect.bottom - box.top,
						x2 = centre + (i - (cards.length - 1) / 2) * px(SPREAD),
						yMid = y1 + px(DROP),
						dir = Math.sign(x2 - x1)

					// The middle card sits over the logo, so its line drops straight down
					lines[i].setAttribute('d', Math.abs(x2 - x1) < r * 2
						? `M${x2},${y1} V${y2}`
						: `M${x1},${y1} V${yMid - r} Q${x1},${yMid} ${x1 + dir * r},${yMid} H${x2 - dir * r} Q${x2},${yMid} ${x2},${yMid + r} V${y2}`)

					arrows[i].setAttribute('d', `M${x2 - a},${y2 - a} L${x2},${y2} L${x2 + a},${y2 - a}`)
				})

				// Not fully drawn yet: re-measure the new lengths when it plays
				if (tl && tl.progress() < 1) tl.invalidate()
			}

			build()

			// Rebuild when the layout changes (ScrollTrigger refreshes on resize)
			ScrollTrigger.create({ trigger: section, onRefresh: build })

			// Reduced motion: the lines are simply shown
			if (!motion) return

			tl = gsap.timeline({
				scrollTrigger: {
					trigger: cardList,
					start: 'bottom 70%',
					toggleActions: 'play none none none',
				},
				// Drop the dash styles so later rebuilds show the full lines
				onComplete: () => gsap.set(lines, { clearProps: 'strokeDasharray,strokeDashoffset' }),
			})

			tl.fromTo(lines, { drawSVG: '0% 0%' }, { drawSVG: '0% 100%', duration: 1.6, ease: 'power1.inOut' })
				.fromTo(arrows, { autoAlpha: 0, y: -6 }, { autoAlpha: 1, y: 0, duration: 0.3, ease: 'power2.out' }, '-=0.15')
		})
	})
}

export default () => { }
